<template>
  <el-dialog
    title="找回密码"
    :visible.sync="dialogVisible"
    width="500px"
    :before-close="handleClose">
    <el-steps :active="active" align-center finish-status="success">
      <el-step title="账户身份验证"></el-step>
      <el-step title="设置新密码"></el-step>
    </el-steps>
    <div class="flex justify-center" style="margin-top: 30px">
      <!-- 账户身份验证 -->
      <div v-if="active == 0">
        <div class="flex align-center">
          <div style="width: 80px">手机号</div>
          <el-input size="small" v-model="mobileFilter" placeholder="请输入手机号" disabled />
        </div>
        <div class="flex align-center" style="margin-top: 20px">
          <div style="width: 80px">验证码</div>
          <el-input size="small" v-model="verifyCode" maxlength="6">
            <template slot="append">
              <el-button size="small" :disabled="codedis" @click="getCode" type="primary">
                {{ codedis ? "已发送" + codemes + "s" : codemes }}
              </el-button>
            </template>
          </el-input>
        </div>
        <p v-if="verifyCodeTip" class="p-tips">{{ verifyCodeTip }}</p>
        <!-- 阿里云滑块验证 -->
        <div class="flex align-center" v-if="showCaptcha" style="margin-top: 20px">
          <div style="width: 100%">
            <div id="captcha-button-find-password"></div>
            <div id="ali-captcha-find-password"></div>
          </div>
        </div>
      </div>
      <!-- 设置新密码 -->
      <div v-if="active == 1">
        <div class="flex align-center">
          <div style="width: 80px">新密码</div>
          <PassWord ref="newPasswordRef" :psd.sync="newPassword">
            <p v-if="newPwTip" class="p-tips">{{ newPwTip }}</p>
          </PassWord>
        </div>
        <div class="flex align-center" style="margin-top: 20px">
          <div style="width: 80px">确认新密码</div>
          <PassWord ref="verifyPasswordRef" :psd.sync="verifyPassword">
            <p v-if="verifyPwTip" class="p-tips">{{ verifyPwTip }}</p>
          </PassWord>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" size="small" v-if="active == 1" @click="lastStep">上一步</el-button>
      <el-button type="primary" size="small" v-if="active == 0" @click="nextStep">下一步</el-button>
      <el-button
        type="primary"
        size="small"
        v-if="active == 1"
        @click="handleValidation"
        :loading="false"
        >保存</el-button
      >
      <el-button size="small" @click="handleClose">取消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { sendSmsPwdCode, validCode, updatePwd } from "@/api/home.js";
import { getCaptchaV2 } from "@/utils/aliWaterBox.js";
import { reqCompanyDetail } from "@/api/hy";
import { bankCardList } from "@/api/public";
import * as types from "@/store/action-types";
import Vue from "vue";
import md5 from "js-md5";
import PassWord from "./password.vue";

export default {
  data() {
    return {
      /** 阿里云滑块验证是否显示 */
      showCaptcha: false,
      /** 弹窗开关 */
      dialogVisible: false,
      /** 手机号过滤显示 */
      mobileFilter: "",
      /** 银行卡列表 */
      bankCardFilterList: [],
      /** 步骤条索引 */
      active: 0,
      /** 验证码发送状态 */
      codedis: false,
      /** 验证码倒计时文案 */
      codemes: "获取验证码",
      /** 验证手机号 */
      mobile: "",
      /** 验证码 */
      verifyCode: "",
      /** 验证码提示 */
      verifyCodeTip: "",
      /** 新密码输入框 */
      newPassword: "",
      /** 新密码提示 */
      newPwTip: "",
      /** 确认密码输入框 */
      verifyPassword: "",
      /** 确认密码提示 */
      verifyPwTip: "",
      /** 保存按钮加载状态 */
      loading: false,
    };
  },
  components: {
    PassWord,
  },
  methods: {
    /** 上一步 */
    lastStep() {
      this.handleReset();
      if (this.active-- < 0) this.active = 0;
    },
    /** 下一步 */
    async nextStep() {
      if (!this.verifyCode) return (this.verifyCodeTip = "请输入验证码");
      if (this.verifyCode?.length != 6) return (this.verifyCodeTip = "验证码长度为6位");
      const res = await validCode({
        mobile: this.mobile,
        verifyCode: this.verifyCode,
      });
      if (res.code && res.code != 0)
        return this.$YTmsg(res.message || "验证码校验失败,请重新输入", "error");
      if (this.active++ > 2) this.active = 0;
    },
    /** 获取验证码 */
    async getCode() {
      if (!this.$verify.phone(this.mobile)) {
        return this.$YTmsg("手机号码格式不正确", "error");
      }
      /** 阿里防水墙验证 */
      this.showCaptcha = true;
      await this.$nextTick();
      const captchaVerifyParam = await getCaptchaV2(
        "ali-captcha-find-password",
        "captcha-button-find-password",
      ).finally(() => {
        this.showCaptcha = false;
      });
      this.codedis = true;
      const res = await sendSmsPwdCode({ phone: this.mobile, captchaVerifyParam });
      if (res.code && res.code != 0) {
        this.codedis = false;
        return this.$YTmsg(res.message || "验证码发送失败", "error");
      }
      this.$YTmsg("验证码已发送,请注意查收", "success");
      this.codemes = 60;
      let auth_timer = setInterval(() => {
        this.codemes--; //递减时间
        if (this.codemes <= 0) {
          this.codedis = false;
          this.codemes = "获取验证码";
          clearInterval(auth_timer);
        }
      }, 1000);
    },
    /** 校验 */
    handleValidation() {
      this.newPwTip = "";
      this.verifyPwTip = "";
      if (!this.newPassword) return (this.newPwTip = "请输入密码");
      if (this.newPassword?.length != 6) return (this.newPwTip = "密码长度为6位数字");
      if (!this.verifyPassword) return (this.verifyPwTip = "请输入密码");
      if (this.newPassword != this.verifyPassword) {
        this.verifyPwTip = "两次密码输入不一致,请重新输入";
        this.$refs.newPasswordRef.msg = "";
        this.$refs.verifyPasswordRef.msg = "";
        return;
      }
      /** 检查银行卡后6位 */
      let flag = false;
      this.bankCardFilterList?.map(item => {
        if (item == this.newPassword) {
          return (flag = true);
        }
      });
      /** 手机号后6位 */
      let phoneSub = this.mobile.substring(this.mobile.length - 6);
      /** 检查是否存在连续升序、降序或相同字符 */
      let ascNum = 0;
      let desNum = 0;
      let sameNum = 0;
      for (var i = 1; i < this.newPassword.length; i++) {
        const diff = this.newPassword[i] - this.newPassword[i - 1];
        /** =1时统计升序连续个数，-1时统计降序连续个数，0时统计连续相同个数 */
        if (diff == 1) ascNum += 1;
        else if (diff == -1) desNum += 1;
        else if (diff == 0) sameNum += 1;
      }
      const pwLength = this.newPassword.length - 1;
      if (
        ascNum == pwLength ||
        desNum == pwLength ||
        sameNum == pwLength ||
        this.newPassword == phoneSub ||
        flag
      ) {
        this.verifyPwTip = "密码不得为连续、重复数字，或手机号、银行卡后6位";
        this.$refs.newPasswordRef.msg = "";
        this.$refs.verifyPasswordRef.msg = "";
        return;
      }
      this.submit();
    },
    /** 保存按钮 */
    async submit() {
      this.loading = true;
      const res = await updatePwd({
        mobile: this.mobile,
        verifyCode: this.verifyCode,
        pwd: md5(this.newPassword),
        rePwd: md5(this.verifyPassword),
      });
      if (res.code == 0) {
        this.$YTmsg("修改密码成功", "success");
      } else {
        this.$YTmsg(res.message || "修改密码失败", "error");
      }
      this.handleClose();
    },
    /** 清空弹窗数据 */
    handleReset() {
      this.verifyCode = "";
      this.verifyCodeTip = "";
      this.newPassword = "";
      this.newPwTip = "";
      this.verifyPassword = "";
      this.verifyPwTip = "";
      this.loading = false;
      this.codedis = false;
    },
    handleClose() {
      this.handleReset();
      this.dialogVisible = false;
    },
    openDialog() {
      this.getCompanyAuthDetail();
      this.getlistAccount();
      this.dialogVisible = true;
      this.active = 0;
    },
    /** 获取企业信息 */
    async getCompanyAuthDetail() {
      /** 查询企业详情 */
      const res = await reqCompanyDetail({ id: Vue.ls.get(types.enterpriseId) });
      if (res.code && res.code != 0) {
        return this.$YTmsg(res.message || "获取企业信息失败", "error");
      }
      this.mobile = res.data.telephone;
      this.mobileFilter = this.mobile.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
    },
    /** 查询银行卡列表 */
    async getlistAccount() {
      let config = {
        enterpriseId: Vue.ls.get(types.enterpriseId),
        ifEncrypt: false,
        bankType: "0",
      };
      const res = await bankCardList(config);
      if (res.code && res.code != 0) {
        return this.$YTmsg(res.message || "获取银行卡列表失败", "error");
      }
      this.bankCardFilterList = res.data?.map(item =>
        item.bankCardNo.substring(item.bankCardNo.length - 6),
      );
    },
  },
};
</script>

<style scoped>
.p-tips {
  color: red;
  max-width: 260px;
  position: absolute;
}
</style>
